'use client';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/shadcn/dialog';
import { Button } from '@/components/ui/Button';
import { Field } from '@/components/ui/Field';
import { Input } from '@/components/shadcn/input';
import { toast } from '@/components/ui/Toasts/use-toast';
import { Interview } from '@/types/pulsedb';
import { duplicateInterview } from '@/utils/supabase/actions';
import { useState } from 'react';
import { useAppForm } from '@/utils/hooks/useAppForm';

export default function InterviewDuplicateDialog({
  interview,
  onDuplicated,
  duplicateDialogOpen,
  setDuplicateDialogOpen
}: {
  interview: Interview;
  onDuplicated: (newSlug: string) => void;
  duplicateDialogOpen: boolean;
  setDuplicateDialogOpen: (open: boolean) => void;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { register, handleSubmit, reset } = useAppForm({
    defaultValues: {
      name: interview.name ? interview.name + ' copy' : null
    }
  });

  const duplicateInterviewHandler = async (data: { name: string | null }) => {
    setIsSubmitting(true);
    toast({
      title: 'Interview duplicated'
    });
    const newInterview = await duplicateInterview(interview.id, data);
    if (newInterview) onDuplicated(newInterview.slug);
    setDuplicateDialogOpen(false);
    setIsSubmitting(false);
  };

  return (
    <Dialog
      open={duplicateDialogOpen}
      onOpenChange={(open) => {
        if (!open) {
          setDuplicateDialogOpen(false);
          reset();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Duplicate Interview</DialogTitle>
        </DialogHeader>
        <Field label="Name">
          <Input
            type="text"
            {...register('name')}
            placeholder="Interview Name"
            className="mb-2"
          />
        </Field>
        <DialogFooter>
          <Button
            onClick={handleSubmit((data) => duplicateInterviewHandler(data))}
            disabled={isSubmitting}
            className="mt-2"
            size="sm"
          >
            Duplicate
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
